import { render, staticRenderFns } from "./EventMovieView.vue?vue&type=template&id=edc9f53a&"
import script from "./EventMovieView.vue?vue&type=script&lang=js&"
export * from "./EventMovieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports